module.exports = __webpack_public_path__ + "5907c829496029ca29257f2c657ad509.png";